
window.flash = function (message, type) {
    EventBus.$emit('flash_' + type, { message });
};

window.flash_success = function (message) {
    if (! message) {
        message = lang('Dina ändringar har sparats.', 'Your settings have been saved.');
    }

    flash(message, 'success');
};

window.flash_message = function (message) {
    flash(message, 'message');
};

window.flash_error = function (message) {
    flash(message, 'error');
};

window.clear_flash_errors = function () {
    EventBus.$emit('clear-errors');
};

// Listen for Livewire flash success event
window.addEventListener('flash-success', event => {
    flash_success(event.detail);
});

window.lang = function (sv, en) {
    return (window.locale === 'sv') ? sv : en;
};

window.translation = function (key) {
    if (window.App.translations[key]) {
        return window.App.translations[key];
    }

    return '';
};

window.format_sek = function (amount) {
    if (window.Intl && typeof window.Intl === 'object') {
        return new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    }

    return amount + ' ' + lang('kr', 'SEK');
};

window.format_sek_per_month = function ($amount, $partPayment) {
    let text = window.format_sek($amount) + '/' + lang('mån', 'month');
    if ($partPayment) {
        text += ', ' + lang('varav', 'of which') + ' ' + $partPayment;
    }

    return text;
};
